import { ActionSerializer, UiActionType } from "../../../recoil/types";
import { fetchWithCatch } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

export const SendActionType = async (
  actionType: UiActionType,
  setLoggedOut: (inactivity: boolean) => void,
  access_token?: string,
  metaData: { [field: string]: string } = {},
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchWithCatch(
    `${baseUrl}/api/v1/provider_portal/actions`,
    {
      body: JSON.stringify({
        action_type: actionType,
        meta_data: metaData,
      } as ActionSerializer),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    },
    setLoggedOut,
  );
};
